<template>
    <HighBoard 
        @logOut="logOutClick"
        :userData="userOptions"
        :choosenPage="'dashboard'"
    />
    <div class="main-dask">
        <div class="solo-company" v-for="company, companyName in compressorsList" :key="companyName">
            <CompressorWidget
                v-for="item in company.compressors" :key="item.id"
                :name="item.name"
                :mac="item.mac"
                :type_controller="item.type_controller"
                :pressure_in="item.pressure_in"
                :pressure_out="item.pressure_out"
                :temperature="item.temperature"
                :vibration="item.vibration"
                :error="item.error"
                :errorDescription="getDiscriptionsOfStatus(StatusDescriptions[item.type_controller]?.errors, item.error)"
                :status="item.status"
                :statusDescription="getDiscriptionsOfStatus(StatusDescriptions[item.type_controller]?.status, item.status)"
                :work_percent="item.work_percent"
                :total_time="item.total_time"
                :off_load_time="item.off_load_time"
                :onload_time="item.onload_time"
                :time_air_filter="item.time_air_filter"
                :time_oil="item.time_oil"
                :engine_current="item.current_engine"
                :separator_filter="item.time_separator_filter"
                :time_oil_liquid="item.time_change_oil_liquid"
                :time_el_system="item.time_el_system"
                :voltage="item.voltage"
                :alarm="item.alarm"
                :alarmDescription="getDiscriptionsOfStatus(StatusDescriptions[item.type_controller]?.alarm, item.alarm)"
                :lastDate="item.last_time_writen"
                :id="item.id"
                @open-graf="openGraphWindow"
                @open-param="openParamWindow"
                @open-error="openErrorWindow"
                @open-consubables="openConsumablesWindow"
            />
        </div>
        <Transition name="fade" mode="out-in">
            <WindowGraph
                v-if="switcherGraph"
                @closeWindow="closeGraphWindow"
                :name="graphWindow.name"
                :id="graphWindow.id"
                :mac="graphWindow.mac"
                :type_controller="graphWindow.type_controller"
            />
        </Transition>
        <Transition name="fade" mode="out-in">
            <WindowParam
                v-if="switcherParam"
                @closeWindow="closeParamWindow"
                @goToModem="goToModemPage"
                :id="paramWindow.id"
                :mac="paramWindow.mac"
                :nameCompressor="paramWindow.name"
                :date="paramWindow.date"
                :type_controller="paramWindow.type_controller"
                :company_id="paramWindow.company"
                :dealer_id="paramWindow.dealer"
                :modem_mac="paramWindow.modem_mac"
                :modem_id="paramWindow.modem_id"
            />
        </Transition>
        <Transition name="fade" mode="out-in">
            <WindowError
                v-if="switcherError"
                @closeWindow="closeErrorWindow"
                :id="errorWindow.id"
                :name="errorWindow.name"
                :errorBase="errorWindow.baseError"
            />
        </Transition>
        <Transition name="fade" mode="out-in">
            <WindowConsumables
                v-if="switcherConsumable"
                :compressorId="consubableWindow.id"
                @closeWindow="closeConsumablesWindow"
            />
        </Transition>
    </div>
</template>
<script>

import { mapGetters, mapActions, mapMutations } from 'vuex'
import CompressorWidget from '@/pages/dashboard/CompressorWidget.vue'
import WindowGraph from '@/pages/dashboard/WindowGraph.vue'
import WindowParam from '@/pages/dashboard/WindowParam.vue'
import WindowError from '@/pages/dashboard/WindowError.vue'
import HighBoard from '@/components/Simple_elements/HighBoard.vue'
import WindowConsumables from '@/pages/dashboard/WindowConsumables.vue'

export default {
    name: 'TestDashboard',
    computed: {
        ...mapGetters('user', {
            userOptions: 'getUserOptions',
        }),
        ...mapGetters('compressor', {
            compressorsList: 'getCompressorsList',
            StatusDescriptions: 'getStatusDescriptions'
        }),
    },
    data() {
        return {
            switcherGraph: false,
            switcherParam: false,
            switcherError: false,
            switcherConsumable: false,
            timeOutID: 0,
            paramWindow: {
            },
            graphWindow: {
            },
            errorWindow: {
            },
            consubableWindow: {},
            flagStopTimeout: false,
        }
    },
    components: {
        CompressorWidget,
        WindowGraph,
        WindowParam,
        WindowError,
        HighBoard,
        WindowConsumables
    },
    methods: {
        ...mapMutations('user', {
            setUserParam: 'setUserParam'
        }),
        ...mapActions('compressor', {
            getCompressors: 'getCompressors',
            getStatusDescriptions: 'getStatusDescriptions',
        }),
        logOutClick() {
            this.$router.push('/')

        },
        openGraphWindow(id, name, mac, type_controller) {
            this.switcherGraph = true
            this.graphWindow = {
                id: id,
                name: name,
                mac: mac,
                type_controller: type_controller
            }
        },
        closeGraphWindow() {
            this.switcherGraph = false
            this.graphWindow = {}
        },
        openParamWindow(id, name) {
            this.switcherParam = true
            for (const property in this.compressorsList) {
                this.compressorsList[property].compressors.find(el=>{
                    if (el.id==id && el.name == name) {
                        this.paramWindow.id = el.id
                        this.paramWindow.mac = el.mac
                        this.paramWindow.name = el.name
                        this.paramWindow.date = el.created_date
                        this.paramWindow.company = el.company_id
                        this.paramWindow.dealer = el.dealer_id
                        this.paramWindow.type_controller = el.type_controller
                        this.paramWindow.modem_id = el.modem_id
                        this.paramWindow.modem_mac = el.modem_mac
                    }
                })
            }
        },
        closeParamWindow() {
            this.switcherParam = false
            this.paramWindow = {}
        },
        goToModemPage(id) {
            this.$emit('goToModemPage', id)
        },
        openErrorWindow(id, name, type_controller) {
            this.switcherError = true
            this.errorWindow = {
                id: id,
                name: name,
                baseError: this.StatusDescriptions[type_controller].errors

            }
        },
        closeErrorWindow() {
            this.switcherError = false
            this.errorWindow = {}
        },
        openConsumablesWindow(id) {
            this.switcherConsumable = true;
            this.consubableWindow = {
                id: id
            };
        },
        closeConsumablesWindow() {
            this.switcherConsumable = false;
            this.consubableWindow = {
            };
        },
        getDiscriptionsOfStatus(findArray, code) {
            // console.log(findArray, code)
            if (findArray) {
                let description = 'Неопределенный статус'; 
                findArray.find(el => {
                    if (el.code == code) {
                        description = el.description
                    }
                })
                return description
            } else {
                return ''
            }
        },
        updateData() {
            this.getCompressors(true);
            if (!this.flagStopTimeout) {
                this.timeOutID = setTimeout(this.updateData, 10000)
            }
        }
    },
    created() {
        let userParam = {
            username: "test_user",
            email: "demo@demo.by",
            role: "demo",
            agreement: true,
            notification: {
                telegram: false
            }
        }
        this.setUserParam(userParam);
        this.flagStopTimeout = false
        this.getCompressors(true);
        this.timeOutID = setTimeout(this.updateData, 10000)       
        this.getStatusDescriptions()
        // console.log(this.userOptions)
    },
    beforeUnmount() {
        clearTimeout(this.timeOutID);
        this.flagStopTimeout = true
    }
}

</script>
<style noscoped lang="scss">
// .high-board{
//     width: 100vw;
//     background: #3F51B5;
//     height: 7vh;
//     box-shadow: 3px 13px 8px 0px rgba(34, 60, 80, 0.2);
//     display: flex;
//     align-items: center;
    
//     .logout{
//         cursor: pointer;
//         margin: 0px 1vw;
//         height: 50%;
//         background: #fff;
//         padding: 4px 10px;
//         border-radius: 4px;
//         i{
//             margin: 0px 6px;
//             color:#3f51b5;
//         }
//     }
// }
// .solo-company {
//     overflow: hidden;
//     transition: all .2s ease;
//     padding: 24px 30px;
//     display: grid;
//     grid-template-columns: repeat(3, 1fr);
//     gap: 10px;
// }
// .main-dask{
//     height: 93vh;//issue: should be 93vh
//     // display: flex;
//     // align-items: flex-start;
//     // justify-content: flex-start;
//     // flex-direction: row;
//     // flex-wrap: wrap;
//     // align-content: flex-start;
//     background-image: url("@/assets/imgs/logo-small.png");
//     background-repeat: no-repeat;
//     background-size: 15%;
//     background-position: 99% 99%;
//     padding: 10px 1vw;
//     overflow-y: auto;
// }

</style>



